import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';
import {
  CloseButton, LeftSide, ModalBody, ModalContent, ModalHeader, ProfessionInfoModalStyles, TextContainer, TitleBox,
} from './ProfessionInfoModal.styles';

function SanitariaStranieriInfoModal({ setShowModal, requestInfo }) {
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <ProfessionInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>
                Qui puoi controllare le informazioni su questa offerta.
              </p>
            </TextContainer>
          </LeftSide>
          <CloseButton onClick={() => closeModal()} aria-label="Chiudi">
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </ModalHeader>
        <ModalContent>
          <div className="card-extra-information">
            {requestInfo.sanitaria_stranieri.is_resident === 0
                            && (
                            <>
                              <p className="fw-bold">ASSISTENZA</p>
                              <p className="mt-3">in caso di malattia e/o infortunio</p>
                              <p className="mt-3">- Consulenza medica;</p>
                              <p>- Invio di un medico o di una autoambulanza in Italia;</p>
                              <p>- Segnalazione di un medico specialista;</p>
                              <p>- Rientro sanitario (comprese le spese per rimpatrio della salma fino a Euro 8.000,00);</p>
                              <p>- Rientro con un familiare (fino a Euro 200,00 per rientro in Italia ed Euro 500,00 verso l'Estero);</p>
                              <p>- Viaggio di un familiare (fino a Euro 1.000,00);</p>
                              <p>- Accompagnamento dei minori (fino a Euro 1.000,00);</p>
                              <p>- Rientro dell'assicurato convalescente;</p>
                              <p>- Prolungamento del soggiorno (fino a Euro 40,00 al giorno per massimo tre giorni);</p>
                              <p>- Rientro anticipato (fino a Euro 1.000,00).</p>

                              <p className="fw-bold mt-3">RIMBORSO SPESE MEDICHE</p>

                              <p className="mt-3">In seguito a malattia improvvisa o ad infortunio, nei Paesi che aderiscono al Trattato di Schengen. Rimborso delle spese mediche/farmaceutiche/ospedaliere per cure o interventi urgenti e non procrastinabili, durante il periodo di validità della garanzia. Europ Assistance provvederà al loro rimborso in base al massimale previsto.</p>

                              <p className="mt-2">Per le spese mediche e farmaceutiche, anche in caso di ricovero in Istituto di cura o in luogo attrezzato per il Pronto Soccorso, Europ Assistance terrà a proprio carico i costi, con pagamento diretto sul posto da parte della Struttura Organizzativa e/o come rimborso, fino alla concorrenza di quanto previsto a tale titolo nel Modulo di Polizza (€ 30.000) per Assicurato e per il periodo di validità della Polizza stessa.</p>

                              <p className="mt-2">Nei massimali indicati sono comprese:</p>

                              <p className="mt-2">- le rette di degenza in Istituto di cura prescritto dal medico fino a Euro 200,00 al giorno per Assicurato;</p>
                              <p>- le spese per cure dentarie urgenti, solo a seguito di infortunio, fino a Euro 200,00 per Assicurato;</p>
                              <p>- le spese per riparazioni di protesi, solo a seguito di infortunio, fino a Euro 200,00 per Assicurato</p>

                              <p className="fw-bold mt-3">SCOPERTO</p>

                              <p className="mt-3">Il rimborso viene effettuato, per ogni singolo sinistro, applicando uno scoperto del 20% sulle spese sostenute con un minimo di Euro 52,00 ed un massimo di Euro 2.600,00.</p>

                              <p className="fw-bold mt-3">LIMITE DI SOTTOSCRIZIONE:</p>

                              <p className="mt-3 ">Non è possibile comprare questa polizza se:</p>
                              <p className="mt-3">- un viaggio già iniziato alla data di decorrenza della Polizza,</p>
                              <p>- Invio di un medico o di una autoambulanza in Italia;</p>
                              <p>- si vuole prolungare il viaggio già assicurato,</p>
                              <p>- si vogliono aumentare i massimali e le garanzie previste in polizza.</p>
                            </>
                            )}

            {requestInfo.sanitaria_stranieri.is_resident === 1
                            && (
                            <>
                              <p>Questa polizza assicura i rischi alla persona domiciliata e non residente in Italia, Repubblica di San Marino, Città del Vaticano durante il soggiorno in Italia e/o nei paesi che aderiscono al Trattato di Schengen.</p>
                              <p className="mt-1">
                                La Polizza è indicata per i clienti che non hanno la copertura del SSN italiano, per richiedere o rinnovare il permesso di soggiorno o la residenza.
                              </p>
                              <p className="fw-bold mt-3">ASSISTENZA</p>
                              <p className="mt-3">in caso di malattia e/o infortunio</p>
                              <p className="mt-3">- Consulenza medica;</p>
                              <p>- Invio di un medico o di una autoambulanza in Italia;</p>
                              <p>- Segnalazione di un medico specialista;</p>
                              <p>- Interprete a disposizione;</p>
                              <p>- Rientro sanitario;</p>
                              <p>- Viaggio di un familiare (fino a Euro 1.000,00);</p>
                              <p>- Spese d’Albergo;</p>
                              <p>- Rientro Assicurato Convalescente;</p>
                              <p>- Rimpatrio Salma (fino a Euro 8.000,00);</p>

                              <p className="fw-bold mt-3">RIMBORSO SPESE MEDICHE</p>

                              <p className="mt-3">In seguito a malattia improvvisa o ad infortunio, per spese mediche/farmaceutiche/ospedaliere durante il periodo di validità della garanzia, Europ Assistance provvederà al loro rimborso entro i seguenti massimali:</p>

                              <p className="mt-3">- tutte le spese di ricovero in un Istituto di cura, fino al massimale indicato sul Modulo di Polizza acquistato, tra Euro 10.000,00 ed Euro 30.000,00 per sinistro e per periodo di durata della Polizza.</p>
                              <p className="mt-1">- le spese mediche sostenute nei 60 gg prima e dopo il ricovero, per: visite, esami, accertamenti diagnostici,</p>
                              <p className="mt-1">fino ad Euro 1.500,00 per sinistro e per periodo di durata della Polizza.</p>
                              <p className="mt-1">- le spese mediche sostenute in caso di accesso al pronto soccorso fino al massimo di Euro 300,00 per sinistro e per periodo di durata della Polizza. Queste spese sono rimborsate solo se sono documentabili e prescritte dal pronto soccorso.</p>
                              <p className="mt-1">- le spese per cure dentarie urgenti e non rimandabili a seguito di infortunio fino al massimo di Euro 200,00 per sinistro e per periodo di durata della Polizza.</p>

                              <p className="fw-bold mt-3">SCOPERTO</p>

                              <p className="mt-3">Il rimborso viene effettuato, per ogni singolo sinistro, applicando uno scoperto del 20%.  Lo scoperto non potrà comunque mai essere inferiore Euro 50,00 né superare Euro 1.500,00.</p>

                              <p className="fw-bold mt-3">TERMINI DI CARENZA:</p>

                              <p className="fst-italic">(APPLICABILE SOLO PER LA DURATA ANNUALE - 365 GIORNI)</p>

                              <p className="mt-2">- per le conseguenze di malattie in realtà già presenti prima che la polizza sia attiva, ma non ancora evidenti e a te sconosciute: dopo 180 giorni.</p>

                              <p className="fw-bold mt-3">LIMITE DI ETA’:</p>

                              <p className="mt-2">L’Assicurazione vale per persone fino ad un massimo di 69 anni di età al momento della sottoscrizione della Polizza. Tuttavia, per le persone che compiono 70 anni in corso di contratto la garanzia mantiene la sua validità fino alla scadenza della Polizza.</p>

                            </>
                            )}

          </div>
        </ModalContent>
      </ModalBody>
    </ProfessionInfoModalStyles>
  );
}

export default SanitariaStranieriInfoModal;
